import React from 'react';

import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';

import { cardStyles } from './styles';

export const InboxItemSkeletonCard: React.FC = () => {
  return (
    <Card sx={cardStyles(false)}>
      <CardHeader
        avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
        title={<Skeleton animation="wave" height={16} width="100%" style={{ marginBottom: 6 }} />}
        subheader={<Skeleton animation="wave" height={14} width="40%" />}
      />
      <CardContent
        sx={{
          paddingY: '0',
          '&.MuiCardContent-root:last-child': {
            paddingBottom: '16px',
          },
        }}
      >
        <Skeleton sx={{ height: 70 }} animation="wave" variant="rectangular" />
      </CardContent>
    </Card>
  );
};
